// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9a47becc","453":"4e34b0c6","732":"0d30a7c0"}[chunkId] + ".chunk.js";
};